import { gql } from '@apollo/client';

const showFeatureTopic = gql`
  query ShowFeatureTopic($slug: String!) {
    featureTopicBySlug(slug: $slug) {
      id
      title
      description
      jobs {
        id
        title
        descriptionText
        coverImage
        liked
        accepted
        company {
          name
        }
        characteristicLabels {
          id
          name
        }
      }
    }
  }
`;

const listFeatureTopics = gql`
  query ListFeatureTopics {
    featureTopics {
      data {
        id
        title
        description
        slug
      }
    }
  }
`;

export { showFeatureTopic, listFeatureTopics };
